<template>
	<div>
		<div class="site-footer__middle">
			<div class="container">
				<div class="row">
					<div class="col-xl-2 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
						<div class="footer-widget__column footer-widget__links clearfix">
							<!-- v-long-press="handleSystem" -->
							<h3 class="footer-widget__title"  
								v-long-click="handleDblClick"
							>{{ $t('footer.footer_links_title') }}</h3>
							<ul class="footer-widget__links-list list-unstyled clearfix">
								<li class="footer-widget_item">
									<router-link :to="{ path: 'mbProduct', query: {type: 'software'} }">
										<!-- 软件产品  -->
										{{ $t('footer.footer_links_softwareProducts') }}
										<i class="fa fa-chevron-right footer_icon"></i></router-link>								
								</li>
								<li class="footer-widget_item">
									<router-link :to="{ path: 'mbProduct', query: {type: 'hardware'} }">
										<!-- 硬件产品  -->
										{{ $t('footer.footer_links_hardwareProducts') }}
										<i class="fa fa-chevron-right footer_icon"></i></router-link>
								</li>
								<li class="footer-widget_item">
									<router-link to="mbSolutionList">
										<!-- 解决方案  -->
										{{ $t('footer.footer_links_solution') }}
										<i class="fa fa-chevron-right footer_icon"></i></router-link>
								</li>
								<li class="footer-widget_item">
									<router-link to="mbCase">
										<!-- 应用案例  -->
										{{ $t('footer.footer_links_caseStudies') }}
										<i class="fa fa-chevron-right footer_icon"></i></router-link>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
						<div class="footer-widget__column footer-widget__contact clearfix">
							<!-- <h3 class="footer-widget__title">联系我们</h3> -->
							<ul class="footer-widget__contact-list list-unstyled clearfix">
								<li>
									<div class="icon">
										<span class="icon-telephone"></span>
									</div>
									<div class="text">
										<p><a href="tel:13205318830">(+86)-132-0531-8830</a>{{ $t('footer.footer_contact_manager_wang') }}</p>
									</div>
								</li>
								<li>
									<div class="icon">
										<span class="icon-telephone"></span>
									</div>
									<div class="text">
										<p><a href="tel:18353147789">(+86)-183-5314-7789</a>{{ $t('footer.footer_contact_manager_xu') }}</p>
									</div>
								</li>
								<li>
									<div class="icon">
										<span class="icon-email"></span>
									</div>
									<div class="text">
										<p><a href="mailto:aotaiqunkong@163.com">qunkong@aotaidianqi.com</a></p>
									</div>
								</li>
								<li>
									<div class="icon">
										<span class="icon-pin"></span>
									</div>
									<div class="text">
										<p>
											<!-- 济南市高新区伯乐路282号 -->
											{{ $t('footer.footer_contact_address') }}
											<br></p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<!-- <div class="row">
					<div class="col-xl-7 col-lg-12 col-md-12 wow fadeInUp" data-wow-delay="400ms">
						<div class="footer-widget__column footer-widget__social-box clearfix">
							<div class="site-footer__social">
							
								<div class="site-footer_img" >
									<img src="static/picture/common/atzy.jpg" alt="" srcset=""  >
									<div>
										<span style="color: #fff;">山东奥太焊接云系统</span>
									</div>
								</div>
								
								<div class="site-footer_img" >
									<img src="static/picture/common/app_download.png" alt="" srcset=""  >
									<div>
										<span style="color: #fff;">掌上群控APP</span>
									</div>
								</div>
								
								<div class="site-footer_img" >
									<img src="static/picture/common/app_tool_download.png" alt="" srcset=""  >
									<div>
										<span style="color: #fff;">掌上运维APP</span>
									</div>
								</div>
								<div class="site-footer_img" >
									<img src="static/picture/common/wqk.jpg" alt="" srcset=""  >
									<div>
										<span style="color: #fff;">奥太微群控小程序</span>
									</div>
								</div>

							
							</div>
						</div>
					</div>
				</div> -->
			</div>
		</div>
		<div class="site-footer__bottom">
			<div class="container">
				<div class="row">
					<div class="col-xl-12">
						<div class="site-footer__bottom-inner">
							<p class="site-footer__bottom-text">Copyright &copy;{{ year }} <a target="_blank"
									:href="official">
									<!-- 山东奥太电气有限公司 -->
									{{ $t('footer.footer_copyright_company') }}
								</a>&nbsp; All rights reserved　<a target="_blank"
									href="http://beian.miit.gov.cn/">鲁ICP备15016186号-5</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script >
export default {
    name: 'mbFooter',
    components: {
    },
    data () {
        return {    
			year: new Date().getFullYear(),      
			official: window._address_env_.official || ''
        }
    },
   directives: {
    //     'long-press-ios不能触发': {
    //         bind(el, binding) {
    //             let pressTimer = null
    //             let isLongPress = false
    //             const delay = binding.value?.delay || 1500
                
    //             const startPress = (event) => {
    //                 if (event.type === 'touchstart' && event.touches.length !== 1) return
                    
    //                 isLongPress = false
    //                 pressTimer = setTimeout(() => {
    //                     isLongPress = true
    //                     if (typeof binding.value === 'function') {
    //                         binding.value(event)
    //                     } else if (binding.value?.handler) {
    //                         binding.value.handler(event)
    //                     }
    //                 }, delay)
    //             }
                
    //             const endPress = () => {
    //                 if (pressTimer) {
    //                     clearTimeout(pressTimer)
    //                     pressTimer = null
    //                 }
    //             }
                
    //             el.addEventListener('touchstart', startPress, { passive: true })
    //             el.addEventListener('touchmove', endPress, { passive: true })
    //             el.addEventListener('touchend', endPress, { passive: true })
    //             el.addEventListener('mousedown', startPress)
    //             el.addEventListener('mouseup', endPress)
    //             el.addEventListener('mouseleave', endPress)
                
    //             el._longPressCleanup = () => {
    //                 el.removeEventListener('touchstart', startPress)
    //                 el.removeEventListener('touchmove', endPress)
    //                 el.removeEventListener('touchend', endPress)
    //                 el.removeEventListener('mousedown', startPress)
    //                 el.removeEventListener('mouseup', endPress)
    //                 el.removeEventListener('mouseleave', endPress)
    //                 if (pressTimer) {
    //                     clearTimeout(pressTimer)
    //                     pressTimer = null
    //                 }
    //             }
    //         },
            
    //         unbind(el) {
    //             if (el._longPressCleanup) {
    //                 el._longPressCleanup()
    //             }
    //         }
    //     },

	// 	'long-press':  {
	// 		bind(el, binding) {
	// 			let pressTimer = null
	// 			let isLongPress = false
	// 			const delay = binding.value?.delay || 1500
				
	// 			const startPress = (event) => {
	// 				// ✅ 阻止默认行为（防止 iOS 放大镜/文本选择）
	// 				event.preventDefault()
					
	// 				// ✅ 支持多点触摸（只响应单指）
	// 				if (event.type === 'touchstart' && event.touches.length !== 1) return
					
	// 				isLongPress = false
	// 				pressTimer = setTimeout(() => {
	// 					isLongPress = true
	// 					// 震动反馈（可选）
	// 					if (navigator.vibrate) {
	// 						navigator.vibrate(20)
	// 					}
	// 					if (typeof binding.value === 'function') {
	// 						binding.value(event)
	// 					} else if (binding.value?.handler) {
	// 						binding.value.handler(event)
	// 					}
	// 				}, delay)
	// 			}
				
	// 			const endPress = () => {
	// 				if (pressTimer) {
	// 					clearTimeout(pressTimer)
	// 					pressTimer = null
	// 				}
	// 			}
				
	// 			// ✅ iOS 需要同时监听 touch 和 mouse 事件
	// 			// 禁用 passive 确保 preventDefault 生效
	// 			el.addEventListener('touchstart', startPress, { passive: false })
	// 			el.addEventListener('touchmove', endPress, { passive: false })
	// 			el.addEventListener('touchend', endPress, { passive: false })
	// 			el.addEventListener('touchcancel', endPress, { passive: false })
				
	// 			el.addEventListener('mousedown', startPress)
	// 			el.addEventListener('mouseup', endPress)
	// 			el.addEventListener('mouseleave', endPress)
				
	// 			// ✅ 禁用 iOS 长按菜单和文本选择
	// 			el.style.webkitTouchCallout = 'none'
	// 			el.style.webkitUserSelect = 'none'
	// 			el.style.userSelect = 'none'
				
	// 			el._longPressCleanup = () => {
	// 				el.removeEventListener('touchstart', startPress)
	// 				el.removeEventListener('touchmove', endPress)
	// 				el.removeEventListener('touchend', endPress)
	// 				el.removeEventListener('touchcancel', endPress)
	// 				el.removeEventListener('mousedown', startPress)
	// 				el.removeEventListener('mouseup', endPress)
	// 				el.removeEventListener('mouseleave', endPress)
	// 				if (pressTimer) {
	// 					clearTimeout(pressTimer)
	// 					pressTimer = null
	// 				}
	// 			}
	// 		},
			
	// 		unbind(el) {
	// 			if (el._longPressCleanup) {
	// 				el._longPressCleanup()
	// 			}
	// 		}
	// 	},
	// 	"long-click": {
    // // bind(el, binding) {
    // //     let timer = null
    // //     let isDouble = false
        
    // //     const handler = (event) => {
    // //         if (timer) {
    // //             // 第二次点击 → 双击
    // //             clearTimeout(timer)
    // //             timer = null
    // //             isDouble = true
                
    // //             // 执行双击回调
    // //             if (typeof binding.value === 'function') {
    // //                 binding.value(event)
    // //             } else if (binding.value?.handler) {
    // //                 binding.value.handler(event)
    // //             }
    // //             return
    // //         }
            
    // //         isDouble = false
    // //         timer = setTimeout(() => {
    // //             timer = null
    // //             if (!isDouble) {
    // //                 // 单击（如果不需要单击，可以忽略）
    // //                 // console.log('单击')
    // //             }
    // //         }, 300)
    // //     }
        
    // //     el.addEventListener('click', handler)
        
    // //     el._doubleClickCleanup = () => {
    // //         el.removeEventListener('click', handler)
    // //         if (timer) {
    // //             clearTimeout(timer)
    // //             timer = null
    // //         }
    // //     }
    // // },
    
    // // unbind(el) {
    // //     if (el._doubleClickCleanup) {
    // //         el._doubleClickCleanup()
    // //     }
    // // }

	//    bind(el, binding) {
    //     let timer = null
    //     let clickCount = 0
        
    //     const handler = (event) => {
    //         clickCount++
            
    //         if (clickCount === 1) {
    //             // 第一次点击，等待判断是否是双击
    //             timer = setTimeout(() => {
    //                 // 单击（不触发）
    //                 clickCount = 0
    //                 timer = null
    //             }, 350)
    //         } else if (clickCount >= 2) {
    //             // 第二次点击 → 双击触发
    //             clearTimeout(timer)
    //             timer = null
    //             clickCount = 0
                
    //             // 执行双击回调
    //             if (typeof binding.value === 'function') {
    //                 binding.value(event)
    //             } else if (binding.value?.handler) {
    //                 binding.value.handler(event)
    //             }
    //         }
    //     }
        
    //     el.addEventListener('click', handler)
        
    //     el._doubleClickCleanup = () => {
    //         el.removeEventListener('click', handler)
    //         if (timer) {
    //             clearTimeout(timer)
    //             timer = null
    //         }
    //         clickCount = 0
    //     }
    // },
    
    // unbind(el) {
    //     if (el._doubleClickCleanup) {
    //         el._doubleClickCleanup()
    //     }
    // }
	// 	},

		"long-click": {
			bind(el, binding) {
				let timer = null
				let clickCount = 0
				let pressTimer = null
				let isLongPress = false
				const delay = binding.value?.delay || 1500
				
				// ============================================================
				// 双击检测（通过 click 事件）
				// ============================================================
				const handleClick = (event) => {
					// 如果是长按触发的，忽略
					if (isLongPress) {
						isLongPress = false
						return
					}
					
					clickCount++
					
					if (clickCount === 1) {
						timer = setTimeout(() => {
							clickCount = 0
							timer = null
						}, 350)
					} else if (clickCount >= 2) {
						clearTimeout(timer)
						timer = null
						clickCount = 0
						
						// ✅ 双击触发
						if (typeof binding.value === 'function') {
							binding.value(event)
						} else if (binding.value?.handler) {
							binding.value.handler(event)
						}
					}
				}
				
				// ============================================================
				// 长按检测（备用）
				// ============================================================
				const startPress = (event) => {
					// 防止 iOS 放大镜
					event.preventDefault()
					
					if (event.type === 'touchstart' && event.touches.length !== 1) return
					
					isLongPress = false
					pressTimer = setTimeout(() => {
						isLongPress = true
						// 震动反馈
						if (navigator.vibrate) {
							navigator.vibrate(20)
						}
						// ✅ 长按触发
						if (typeof binding.value === 'function') {
							binding.value(event)
						} else if (binding.value?.handler) {
							binding.value.handler(event)
						}
					}, delay)
				}
				
				const endPress = () => {
					if (pressTimer) {
						clearTimeout(pressTimer)
						pressTimer = null
					}
				}
				
				// ============================================================
				// 注册事件
				// ============================================================
				el.addEventListener('click', handleClick)
				
				// 移动端事件
				el.addEventListener('touchstart', startPress, { passive: false })
				el.addEventListener('touchmove', endPress, { passive: false })
				el.addEventListener('touchend', endPress, { passive: false })
				el.addEventListener('touchcancel', endPress, { passive: false })
				
				// PC 端事件
				el.addEventListener('mousedown', startPress)
				el.addEventListener('mouseup', endPress)
				el.addEventListener('mouseleave', endPress)
				
				// 禁用 iOS 长按菜单
				el.style.webkitTouchCallout = 'none'
				el.style.webkitUserSelect = 'none'
				el.style.userSelect = 'none'
				el.style.cursor = 'pointer'
				
				// ============================================================
				// 清理
				// ============================================================
				el._longClickCleanup = () => {
					el.removeEventListener('click', handleClick)
					el.removeEventListener('touchstart', startPress)
					el.removeEventListener('touchmove', endPress)
					el.removeEventListener('touchend', endPress)
					el.removeEventListener('touchcancel', endPress)
					el.removeEventListener('mousedown', startPress)
					el.removeEventListener('mouseup', endPress)
					el.removeEventListener('mouseleave', endPress)
					if (timer) {
						clearTimeout(timer)
						timer = null
					}
					if (pressTimer) {
						clearTimeout(pressTimer)
						pressTimer = null
					}
					clickCount = 0
				}
			},
			
			unbind(el) {
				if (el._longClickCleanup) {
					el._longClickCleanup()
				}
			}
		}
    },
    methods: {
        // 联系我们 
        handleSeek() {
			this.$emit("handleSeek")
        },
		handleSystem() {
				console.log("长按系统显示")
				// const targetRoute = this.$router.resolve({ path: '/mbSystem' });
				// window.open(targetRoute.href, '_blank');

				this.$router.push({
					path: '/mbSystem'
				});

		},
		handleDblClick() {
			console.log("双击系统显示")
			this.$router.push({
					path: '/mbSystem'
				});
		}
    }
}
</script>
<style scoped>
.site-footer__social {
    display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	/* justify-content: center; */
}

.site-footer-bg-2 {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 625px;
    width: 531px;
    background-color: var(--notech-black);
    background-blend-mode: luminosity;
    background-repeat: no-repeat;
    background-position: bottom center;
    background-size: cover;
    opacity: .12;
    z-index: -1;
}

.site-footer__middle {
    position: relative;
    display: block;
    padding: 20px 0 20px;
}
.footer-widget__links {
    margin-top: 0px;
}
.footer-widget__title {
    margin-bottom: 10px;
}
/* .footer-widget__links-list li a {
	font-size: 16px;
} */
.footer-widget__contact-list li .text p {
    font-size: var(--font-size-14);
}
.footer-widget__contact {
    margin-top: 10px;
}
.site-footer_img {
	display: inline-block;
	text-align: center; 
	width: 50%;
}
.site-footer_img img {
	max-width: 60%;
}
.site-footer_img span {
	font-size: var(--font-size-14)
}
.site-footer__bottom-text {
    font-size: 12px;
	line-height: 20px;
}
.site-footer__bottom-inner {
    padding: 5px 0;
}
.footer_icon {
	float: right;
    font-size: 20px;
    color: #fff;
	line-height: 30px;
} 
.footer-widget_item a{
	font-size: var(--font-size-16);
    color: var(--notech-white);
	font-weight: 700;
}
/* font-size: var(--font-size-16);
    color: var(--notech-white);
    line-height: 28px;
    font-weight: 700; */
</style>